import { useUiStore } from '.'
import { IPoint } from './interfaces'

export const toggleFilterPanelCollapsed = () => {
  const uiStore = useUiStore()

  if (!uiStore.filterPanelPinned) {
    uiStore.filterPanelCollapsed = !uiStore.filterPanelCollapsed
  }
}

export const showDetailsPanel = () => {
  const uiStore = useUiStore()

  if (!uiStore.filterPanelPinned) {
    uiStore.filterPanelCollapsed = true
  }

  uiStore.detailsPanelCollapsed = false
}

export const hideDetailsPanel = () => {
  const uiStore = useUiStore()

  uiStore.filterPanelCollapsed = false
  uiStore.detailsPanelCollapsed = true
}

export const setDetailsPanelActiveTab = (tabName: string) => {
  const uiStore = useUiStore()

  uiStore.detailsPanelActiveTab = tabName
}

export const showTooltip = ({ name, pos }: { name: string; pos?: IPoint }) => {
  const uiStore = useUiStore()

  uiStore.tooltips[name].pos.x = pos?.x ?? 0
  uiStore.tooltips[name].pos.y = pos?.y ?? 0
  uiStore.tooltips[name].show = true
}

export const hideTooltip = (name: string) => {
  const uiStore = useUiStore()

  uiStore.tooltips[name].show = false
}

export default {
  toggleFilterPanelCollapsed,
  showDetailsPanel,
  hideDetailsPanel,
  setDetailsPanelActiveTab,
  showTooltip,
  hideTooltip,
}
